import { render, staticRenderFns } from "./QdbAgreement.vue?vue&type=template&id=2b381fe0&scoped=true&"
import script from "./QdbAgreement.vue?vue&type=script&lang=js&"
export * from "./QdbAgreement.vue?vue&type=script&lang=js&"
import style0 from "./QdbAgreement.vue?vue&type=style&index=0&id=2b381fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b381fe0",
  null
  
)

export default component.exports